// extracted by mini-css-extract-plugin
export default {"package-manager":"packageManager_package-manager__IVvFK"};